<template>
  <div class="score-list">
    <div
      v-for="score in scores"
      :key="score.title"
      class="score-list__item"
    >
      <ScoreItem :score="score" />
    </div>
  </div>
</template>

<script>
  import ScoreItem from 'src/components/ratings/ScoreItem/ScoreItem.vue';
  
  export default {
    name: 'ScoreList',
    components: { ScoreItem },
    props: {
      scores: {
        type: Array,
        required: true,
      }
    }
  }
</script>